import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  data: {
    rep: [],
    tDr: 0,
    tCr: 0
  },
  dt1: null,
  dt2: null,
  sDate: '',
  ixBrch: 0,
  lst_jcd: [],
  loading: false,
  brch: {
    lst_brch: []
  }
};

const slice = createSlice({
  name: 'gj',
  initialState: INITIAL_STATE,
  reducers: {
    setData(state, action) {
      state.data.rep = action.payload.rep;
      state.data.tCr = action.payload.tCr;
      state.data.tDr = action.payload.tDr;
    },
    setDateRange(state, action) {
      state.dt1 = action.payload.dt1;
      state.dt2 = action.payload.dt2;
      state.sDate = action.payload.textValue;
    },
    setBranch(state, action) {
      state.ixBrch = action.payload;
    },
    setLstJcd(state, action) {
      state.lst_jcd = action.payload;
    },
    setLstBrch(state, action) {
      if (!state.brch) {
        state.brch = { lst_brch: [] };
      }
      state.brch.lst_brch = action.payload;
    },
    restore(_, action) {
      return action.payload || INITIAL_STATE;
    },
    clear() {
      return INITIAL_STATE;
    }
  }
});

const gjReducer = slice.reducer;

export const {
  setDateRange,
  setData,
  setBranch,
  setLstJcd,
  setLstBrch,
  setPage,
  setLimit,
  restore,
  clear
} = slice.actions;
export default gjReducer;
